import { render, staticRenderFns } from "./select-responsibilities.vue?vue&type=template&id=584ab722"
import script from "./select-responsibilities.vue?vue&type=script&lang=js"
export * from "./select-responsibilities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports